class About {
  constructor(el,opt){
    this.el = el;
    this.flag = false;
    this.chartCreated = false; // フラグを追加
    if($("." + this.el).length > 0){
      this.event();
      this.initObserver();
    }
  }

  initObserver() {
    const optionsCircle = {
      threshold: 0.5  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observerCircle = new IntersectionObserver((entries) => {
      this.circleGraphAnime(entries);
    }, optionsCircle);

    observerCircle.observe(document.querySelector('.js-circle-graph'));


    const optionsLine = {
      threshold: 0.5  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observerLine = new IntersectionObserver((entries) => {
      this.lineGraphAnime(entries);
    }, optionsLine);

    observerLine.observe(document.querySelector('.js-line-graph'));
  }

  circleGraphAnime(entries) {

    entries.forEach(entry => {
      if(entry.intersectionRatio >= 0.05){

        setTimeout(() => {
          $('.js-circle-graph-txt').fadeIn();
        }, 1000);


        var ctx = document.getElementById('myPieChart').getContext('2d');
        var myPieChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Red', 'Red', 'Red', 'Red', 'Red', 'Red'], // Adding more labels for more slices
            datasets: [{
              label: '# of Votes',
              data: [22, 18, 15, 13, 18, 4], // All data points are equal
              backgroundColor: [
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)'
              ],
              borderColor: [
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)'
              ],
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                enabled: false
              }
            },
            animation: {
              duration: 1000, // Animation duration in milliseconds
              easing: 'easeOutCirc', // Easing function
              animateRotate: true, // Enable rotation animation
            }
          }
        });
        this.chartCreated = true; // フラグを設定して、チャートが作成されたことを示す
      }
    });
  }

  lineGraphAnime(entries) {
    let barThickness;
    if (window.matchMedia("(min-width:1101px)").matches) {
      barThickness = 87;
    } else {
      barThickness = 50;
    }

    entries.forEach(entry => {
      if(entry.intersectionRatio >= 0.05){

        setTimeout(() => {
          $('.js-line-graph-txt').animate({'opacity': '1'}, 500);
        }, 800);

        const ctx = document.getElementById('myBarChart').getContext('2d');
        const myBarChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['', '', '', '', ''], // ラベルなし
            datasets: [{
              data: [3, 3.4, 4, 5, 7],
              backgroundColor: [
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 1)'
              ], // 赤色
              barThickness: barThickness // バーの幅を30に設定
            }]
          },
          options: {
            plugins: {
              legend: {
                display: false // データセットのラベルを表示しない
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                grid: {
                  display: false // 背景の線を表示しない
                },
                border: {
                  display: false // y軸の境界線を非表示にする
                },
                ticks: {
                  display: false // 目盛りを表示しない
                }
              },
              x: {
                grid: {
                  display: false // 背景の線を表示しない
                },
                ticks: {
                  display: false // 目盛りを表示しない
                }
              }
            }
          }
        });
      }
    });
  }

  event(){
    if (window.matchMedia("(min-width:1101px)").matches) {
      $('.js-trigger > div').click(
        function() {
          if(!$('.js-change > img').eq($(this).index()).hasClass('is-active')) {
            $('.js-change > img').removeClass('is-active');
            $('.js-change > img').css({'display': 'none'});
            $('.js-change > img').eq($(this).index()).addClass('is-active');
            $('.js-change > img').eq($(this).index()).fadeIn();
          }
        }
      );
  
      $('.js-toggle-trigger').click(
        function() {
          var isActive = $(this).find('.js-toggle-inner').is(':visible');
  
          // すべてのアコーディオンを閉じる
          $('.js-toggle-inner').fadeOut(1);
          $('.js-toggle-cls').removeClass('is-active');
  
          // 現在の要素がもともと閉じていた場合のみ開く
          if (!isActive) {
            $(this).find('.js-toggle-inner').fadeToggle();
            $(this).find('.js-toggle-cls').toggleClass('is-active');
          }
        }
      );
    } else {
      $('.js-toggle-accordion').click(function() {
        var isActive = $(this).next().is(':visible');
  
        // 他の開いているアコーディオンを閉じる
        $('.js-toggle-accordion').not(this).find('.js-toggle-cls').removeClass('is-active');
        $('.js-toggle-accordion').not(this).next().slideUp();
  
        // 現在の要素がもともと閉じていた場合のみ開く
        $(this).find('.js-toggle-cls').toggleClass('is-active');
        $(this).next().slideToggle();
      });
    }
  }
    
}